/** A standard menu containing a user's gallections generally used as the
 *  target of some action like where to move a deviation or other folder */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { convertToFoldersWithSubfolders } from '../../../utils/folders';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import withCurrentSubfolder from '../../_hocs/withCurrentSubfolder';
import withGallections from '../../_hocs/withGallections';
import { getCanEditGallection, isSpecialFullyLockedFolder } from '../../helpers';
import { getAllGallections } from '../../selectors';
import StandardMenu from '../../../Dropdown/MenuPreset/StandardMenu';
import { isPremiumGallection } from '../../../utils/gallections';
import TextTooltipOnHover from '../../../Popover/Preset/TextTooltipOnHover';
import PremiumIcon from '../../../DeviationViews/Helper/PremiumIcon';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import gallectionListMenuStyles from './GallectionListMenu.scss';
const enhance = compose(withCurrentGallection, withCurrentSubfolder, withGallections, connectMediaStore((state)=>({
        allGallections: getAllGallections(state)
    })));
const GallectionListMenu = ({ className, onSelect, allGallections, onlyTopLevelFolders, disableFolderIds = [], disableReasonHint, firstItem, currentFolderId, currentSubfolderId, excludeFolderIds = [] })=>{
    /** is a given folder shown in this gallection menu */ const isFolderShown = (folder)=>{
        const currentGallectionId = currentSubfolderId || currentFolderId;
        return(// a folder itself is not a target of it's own actions
        folder.folderId !== currentGallectionId && // don't target a non-manageable folder
        !isSpecialFullyLockedFolder(folder) && // given disabled folders aren't shown
        !excludeFolderIds.includes(folder.folderId));
    };
    /** build an array of dropdown items to be used in the final menu */ const buildDropdownItemsFromFolders = ()=>{
        const menuItems = [];
        const foldersWithSubfolders = convertToFoldersWithSubfolders(allGallections);
        foldersWithSubfolders.forEach((folder)=>{
            var _folder_subfolders;
            const parentFolderShown = isFolderShown(folder);
            let icon;
            const label = folder.name;
            if (isPremiumGallection(folder)) {
                icon = /*#__PURE__*/ React.createElement(PremiumIcon, {
                    premiumFolderData: folder.premiumFolderData,
                    withTooltip: false,
                    size: IconSize.SMALLER
                });
            }
            const disabled = !getCanEditGallection(folder) || disableFolderIds.includes(folder.folderId);
            const parentDropdownItem = _object_spread({
                value: folder.folderId,
                disabled,
                icon,
                label: disabled && disableReasonHint ? /*#__PURE__*/ React.createElement(TextTooltipOnHover, {
                    placement: "right",
                    tooltipText: disableReasonHint,
                    renderReference: ({ ref })=>/*#__PURE__*/ React.createElement("span", {
                            style: {
                                pointerEvents: 'all'
                            },
                            ref: ref
                        }, label)
                }) : label
            }, !parentFolderShown && {
                disabled: true
            });
            var _folder_subfolders_filter_map;
            const subfolderItems = onlyTopLevelFolders ? [] : (_folder_subfolders_filter_map = (_folder_subfolders = folder.subfolders) === null || _folder_subfolders === void 0 ? void 0 : _folder_subfolders.filter(isFolderShown).map((subfolder)=>({
                    value: subfolder.folderId,
                    disabled: !getCanEditGallection(subfolder) || disableFolderIds.includes(subfolder.folderId),
                    label: subfolder.name,
                    className: gallectionListMenuStyles['subfolder']
                }))) !== null && _folder_subfolders_filter_map !== void 0 ? _folder_subfolders_filter_map : [];
            // note: even if the parent folder shouldn't be shown, it's subfolders might be
            // in that case, show the parent folder as disabled
            if (subfolderItems.length || parentFolderShown) {
                menuItems.push(parentDropdownItem);
            }
            menuItems.push(...subfolderItems);
        });
        if (firstItem) {
            return [
                {
                    items: [
                        firstItem
                    ]
                },
                {
                    items: menuItems
                }
            ];
        }
        return menuItems;
    };
    return /*#__PURE__*/ React.createElement(StandardMenu, {
        id: "gallection-list-menu",
        lightText: true,
        className: classnames(gallectionListMenuStyles['root'], className),
        items: buildDropdownItemsFromFolders(),
        onSelect: onSelect
    });
};
GallectionListMenu.displayName = 'GallectionListMenu';
export default enhance(GallectionListMenu);
